import { ReactElement } from "react";
import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  Page404,
  ExamplePage,
  EXAMPLE_PAGE_PATH,
  WorkerCompApplicationModel,
  HealthInsuranceApplicationModel,
  FindHIAppModel,
  PreQualificationModel,
  PrimaryBusinessAddressModel,
  CurrentCoverageModel,
  CensusAndCurrentInformationModel,
  ResultPageModel,
  CurrentEmployees,
  NewCurrentEmployees,
  NewCobraCensus,
  HealthApplicationStatusModel,
  CurrentInsuranceModel,
  CurrentInvoice,
  SBCInvoice,
  RenewalRateInvoice,
} from "pages";
import Loader from "uicomponents/Loader";
import RequiredAuth from "./SecureRoute";
import CobraCensusModel from "pages/CensusAndCurrentInformation/components/CobraCensus";
import { isTestUser, getAppType } from "utils/helper";

const Viewport = (): ReactElement => {
  const { authState, oktaAuth } = useOktaAuth();
  const { pathname } = useLocation();

  if (!authState?.accessToken && pathname === "/" && !isTestUser) {
    oktaAuth.signInWithRedirect();

    return <></>;
  }

  const appType = getAppType();
  const showNewCensusUi = appType === "HEALTH_INSURANCE";

  return (
    <div aria-label="app-viewport">
      <Routes>
        <Route path="*" element={<Page404 />} />
        <Route path={EXAMPLE_PAGE_PATH} element={<ExamplePage />} />
        <Route
          path="/health-insurance-application/invoice_sample_document"
          element={<CurrentInvoice />}
        />
        <Route
          path="/health-insurance-application/sbc_sample_document"
          element={<SBCInvoice />}
        />
        <Route
          path="/health-insurance-application/renewal_rate_sample_document"
          element={<RenewalRateInvoice />}
        />
        <Route
          path="/worker-comp-application/test-user-flow"
          element={<WorkerCompApplicationModel />}
        />
        {["/health-insurance-application-mdv/:companyUuid"].map(
          (path: string) => (
            <Route
              key={path}
              path={path}
              element={
                <RequiredAuth>
                  <HealthInsuranceApplicationModel />
                </RequiredAuth>
              }
            />
          )
        )}
        <Route
          path="/health-insurance-application/:companyUuid"
          element={
            <RequiredAuth>
              <FindHIAppModel />
            </RequiredAuth>
          }
        />
        <Route
          path="/pre-qualification/test-user-flow/"
          element={<PreQualificationModel />}
        >
          <Route path={"1"} element={<PrimaryBusinessAddressModel />} />
          <Route path={"2"} element={<CurrentCoverageModel />} />
          <Route path={"3"} element={<ResultPageModel />} />
        </Route>
        <Route
          path="/census-and-current-information/test-user-flow"
          element={<CensusAndCurrentInformationModel />}
        >
          {showNewCensusUi ? (
            <Route path={"5"} element={<NewCurrentEmployees />} />
          ) : (
            <Route path={"5"} element={<CurrentEmployees />} />
          )}
          <Route path={"6"} element={<CurrentInsuranceModel />} />
          {showNewCensusUi ? (
            <Route path={"7"} element={<NewCobraCensus />} />
          ) : (
            <Route path={"7"} element={<CobraCensusModel />} />
          )}
        </Route>
        <Route
          path="/health-application-status/test-user-flow"
          element={<HealthApplicationStatusModel />}
        />
        <Route
          path="login/callback"
          element={<LoginCallback loadingElement={<Loader />} />}
        />
        <Route
          path="/worker-comp-application/:companyUuid"
          element={
            <RequiredAuth>
              <WorkerCompApplicationModel />
            </RequiredAuth>
          }
        />
        {[
          "/pre-qualification/:companyUuid/",
          "/pre-qualification-mdv/:companyUuid/",
        ].map((path: string) => (
          <Route
            key={path}
            path={path}
            element={
              <RequiredAuth>
                <PreQualificationModel />
              </RequiredAuth>
            }
          >
            <Route path={"1"} element={<PrimaryBusinessAddressModel />} />
            <Route path={"2"} element={<CurrentCoverageModel />} />
            <Route path={"3"} element={<ResultPageModel />} />
          </Route>
        ))}
        {[
          "/census-and-current-information/:companyUuid/",
          "/census-and-current-information-mdv/:companyUuid/",
        ].map((path: string) => (
          <Route
            key={path}
            path={path}
            element={
              <RequiredAuth>
                <CensusAndCurrentInformationModel />
              </RequiredAuth>
            }
          >
            {showNewCensusUi ? (
              <Route path={"5"} element={<NewCurrentEmployees />} />
            ) : (
              <Route path={"5"} element={<CurrentEmployees />} />
            )}

            <Route path={"6"} element={<CurrentInsuranceModel />} />

            {showNewCensusUi ? (
              <Route path={"7"} element={<NewCobraCensus />} />
            ) : (
              <Route path={"7"} element={<CobraCensusModel />} />
            )}
          </Route>
        ))}
        {[
          "/health-application-status/:companyUuid/",
          "/health-application-status-mdv/:companyUuid/",
        ].map((path: string) => (
          <Route
            key={path}
            path={path}
            element={
              <RequiredAuth>
                <HealthApplicationStatusModel />
              </RequiredAuth>
            }
          />
        ))}
      </Routes>
    </div>
  );
};

export default Viewport;
